import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";

const COOKIE_CONSENT_KEY = "cookie_consent_accepted";

const EXCLUDED_PATHS: readonly string[] = [
  ROUTES.PRIVACY_POLICY,
  ROUTES.USER_AGREEMENT,
  ROUTES.PERSONAL_DATA_AGREEMENT,
];

export const useCookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Не показываем на исключенных страницах
    if (EXCLUDED_PATHS.includes(location.pathname)) {
      setIsVisible(false);
      return;
    }

    const hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, [location.pathname]);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    setIsVisible(false);
  };

  return { isVisible, acceptCookies };
};
